import * as THREE from "three";

export interface ScreenPoint {
  x: number;
  y: number;
  visible: boolean;
}

const projected = new THREE.Vector3();

/** Shared by nameplates and floating combat numbers. */
export function projectToScreen(
  worldPosition: THREE.Vector3Like,
  camera: THREE.Camera,
  canvas: HTMLCanvasElement,
): ScreenPoint {
  projected.set(worldPosition.x, worldPosition.y, worldPosition.z).project(camera);
  const rect = canvas.getBoundingClientRect();
  return {
    x: rect.left + ((projected.x + 1) / 2) * rect.width,
    y: rect.top + ((1 - projected.y) / 2) * rect.height,
    visible: projected.z <= 1,
  };
}

export interface Nameplate {
  setText(text: string): void;
  update(worldPosition: THREE.Vector3Like, camera: THREE.Camera, canvas: HTMLCanvasElement): void;
  dispose(): void;
}

/**
 * A DOM label above a cat. The name is player-authored, so it is written with
 * `textContent` and never through `innerHTML` (R29) — the same treatment chat
 * messages get.
 */
export function createNameplate(text: string, parent: HTMLElement = document.body): Nameplate {
  const element = document.createElement("div");
  element.className = "nameplate";
  element.textContent = text;
  parent.appendChild(element);

  return {
    setText: (next) => {
      element.textContent = next;
    },
    update: (worldPosition, camera, canvas) => {
      const point = projectToScreen(worldPosition, camera, canvas);
      if (!point.visible) {
        element.style.display = "none";
        return;
      }
      element.style.display = "block";
      element.style.left = `${point.x}px`;
      element.style.top = `${point.y}px`;
    },
    dispose: () => {
      element.remove();
    },
  };
}
